import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getDefaultManualEntry = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.defaultManualEntry;
  }
);
